<template>
  <div class="affirmorderindex">
    <GlobTopNav title="确认订单"></GlobTopNav>
    <div class="pop" v-if="lodingshow"><van-loading type="spinner" /></div>
    <div style="padding-bottom: 0.6rem" class="van-content">
      <div class="tishi" v-if=" dummy == 3">
        *请仔细核对
        <span v-html="dummy == 2 ? '充值' : '收货人'"></span>
        手机号码，
        <span v-html="dummy == 2 ? '充值' : '下单'"></span>
        完成后将无法退款哦！
      </div>
      <!--手机号码-->
      <van-cell-group style="margin-bottom: 0.2rem" v-if="dummy == 3">
        <van-field
          type="number"
          style="color: #333"
          v-model="mobile"
          label="收货人手机号码"
          placeholder="请填写接收短信的11位手机号码"
        />
      </van-cell-group>



      <!--地址-->
      <!--<van-address-list style="padding-bottom: 0" class="address-list"  v-model="chosenAddressId"  @edit="chooseSite" v-if="siteList[0].id != ''&&datas.product_list[0].dummy != 1 && datas.product_list[0].dummy != 2">-->
      <!--</van-address-list>-->
      <div
        v-if="dummy != 2 && dummy != 3 && getid != ''"
        class="van-cell-group van-hairline--top-bottom hasAddress"
      >
        <div
          @click="chooseSite"
          class="van-cell van-cell--clickable van-address-item"
        >
          <div
            style="padding-right: 0.19rem"
            class="van-cell__value van-cell__value--alone"
          >
            <div class="van-radio" style="position: relative">
              <!-- <i
                class="van-icon iconfont icon-shouhuodizhi"
                style="position: absolute; top: 50%; margin-top: -0.08rem; line-height: 0.16rem"
              ></i> -->
              <img src="./../../assets/img/order-dw.svg" alt="" />
              <span class="van-radio__label">
                <div class="van-address-item__name">
                  {{ getname }} &#8194;
                  <span class="float-right">{{ enStr(gettel) }}</span>
                </div>
                <div class="van-address-item__address">{{ getaddress }}</div>
              </span>
            </div>
          </div>
          <van-icon
            style="
              position: absolute;
              right: 0.2rem;
              top: 50%;
              margin-top: -0.08rem;
            "
            name="arrow"
          />
        </div>
      </div>
      <router-link
        v-if="dummy != 2 && dummy != 3 && getid == ''"
        to="user/mysite/addsite"
        class="van-cell-group van-hairline--top-bottom"
      >
        <div class="van-cell van-hairline add_address">
          <div class="van-cell__value van-cell__value--alone">
            请添加收货地址
            <i
              style="font-size: 0.32rem; color: rgba(38, 38, 38, 0.3)"
              class="van-icon van-icon-arrow van-notice-bar__right-icon"
            ></i>
          </div>
        </div>
        <!--商品信息-->
      </router-link>
      <van-card class="goodsonelist" v-for="items in datas" :key="items.id">
        <div slot="thumb" class="goodsimgbox">
          <img :src="items.image" onerror="src='/static/errorimg1.png'" />
        </div>
        <div slot="title" class="ellipseal van-card-title product-name">
          <span class="tagbox">
            <span class="tag xl" v-if="items.source == 4">一乡一物</span>
            <span class="tag xl" v-if="items.source == 3">卡券</span>
            <span class="tag zc" v-if="items.source == 2">直充</span>
            <span plain class="tag jd" v-if="items.source == 1">优选</span>
            <span class="tag yx" v-if="items.source == 6">严选</span>
          </span>
          {{ items.name }}
        </div>

        <div slot="desc" class="van-card-desc theme-col">
          <span class="price">
            <span v-if="items.point">{{ items.point }}{{ unit }}</span>
            <span v-if="items.cash">
              <span><span v-if="items.point">+</span>{{ items.cash }}</span>
              <span>元</span>
            </span>
          </span>
          <span class="num">× {{ items.number }}</span>
        </div>
      </van-card>

      <div class="van-cell-group text-right" style="margin-bottom: 0">
        <div class="allinfo">
          <span class="allinfo-left">共{{ nums }}件商品</span>
          <span class="allinfo-right">
            合计：<span v-if="totalPoints">{{ totalPoints }}{{ unit }}</span>
            <span v-if="totalCash"><span v-if="totalPoints">+</span>{{ totalCash }}元 </span>
          </span>
        </div>
      </div>
            <van-cell-group class="mobile-box" v-if="this.dummy === 2">
         <div v-for="(vo,key) in inputTp" :key="key">
          <div  v-if="vo.name=='charge_num'" >
              <div v-if="isChangeNumShow(vo)">

               <!-- <van-field v-model="extParams[vo.name]" :label="vo.title" :placeholder="vo.placeholder" /> -->
              <van-field
                  v-model="extParams[vo.name]"
                  is-link
                  readonly
                  name="picker"
                :label="vo.title"
                  @click="numPicker = true"
                />
                    <van-popup v-model:show="numPicker" position="bottom">
            <van-picker
              :columns="vo.enum"
              :show-toolbar="true"
              @confirm="numConfirm"
              @cancel="numPicker = false"
            />
          </van-popup>
             </div>
            <div v-else style="display:flex;    justify-content: space-between;
    padding: 0 0.3rem;">

              <span>{{vo.title}}</span> <span>可输入范围{{vo.range[0][0]}}-{{vo.range[0][1]}}</span>
              <van-stepper v-model="extParams[vo.name]" :min="vo.range[0][0]" :max="vo.range[0][1]" integer  @change="onChangeNum" />
            </div>

             </div>
           <van-field v-else v-model="extParams[vo.name]" :label="vo.title" :placeholder="vo.title" />
         </div>


        <div v-if="game.gameList.length > 0">
          <van-field
            v-model="extParams['charge_game_name']"
            is-link
            readonly
            name="picker"
            label="选择游戏"
            placeholder="点击选择游戏"
            @click="game.gamePicker = true"
          />
          <van-popup v-model:show="game.gamePicker" position="bottom">
            <van-picker
              :columns="game.gameList"
              value-key="game_name"
              :show-toolbar="true"
              @confirm="gameConfirm"
              @cancel="game.gamePicker = false"
            />
          </van-popup>
        </div>

        <div v-if="game.gameRegionServer.length > 0">
          <van-field
            v-model="game.gameRegionServerText"
            is-link
            readonly
            name="picker"
            label="选择游戏区服"
            placeholder="点击选择游戏区服"
            @click="game.gameRegionServerPicker = true"
          />
          <van-popup v-model:show="game.gameRegionServerPicker" position="bottom">
            <van-picker
              :columns="game.gameRegionServer"
              value-key="text"
              :show-toolbar="true"
              @confirm="gameRegionServerConfirm"
              @cancel="game.gameRegionServerPicker = false"
            />
          </van-popup>
        </div>

        <div v-if="game.chargetype.length > 0">
          <van-field
            v-model="extParams['charge_type']"
            is-link
            readonly
            name="picker"
            label="选择充值方式"
            placeholder="点击选择充值方式"
            @click="game.chargetypePicker = true"
          />
          <van-popup v-model:show="game.chargetypePicker" position="bottom">
            <van-picker
              :columns="game.chargetype"
              :show-toolbar="true"
              @confirm="chargetypePickerConfirm"
              @cancel="game.chargetypePicker = false"
            />
          </van-popup>
        </div>
      <van-cell-group style="margin-bottom: 0.2rem" v-if="dummy == 2">
        <van-field
          type="number"
          style="color: #333"
          v-model="mobile"
          label="通知号码"
          placeholder="请填写11位手机号码"
        />
                <div class="tishi" v-if=" dummy == 2">
        *用以接受发货通知短信，不填写将无法收到发货通知
      </div>
      </van-cell-group>
      </van-cell-group>
      <!-- <ext-param ref="ext" :extparams="datas[0].extParams"></ext-param> -->
      <!--备注-->
      <!-- van-cell van-hairline van-field -->
      <div v-if="dummy != 2 && dummy != 3" class="beizhu">
        <!-- <div class="van-cell__title" style="flex: 0.3">备注</div>
        <div class="van-cell__value">
          <textarea
            @input="descInput"
            placeholder="备注文字限制在200字以内"
            v-model="content"
            class="van-field__control"
            style="height: 32px"
            maxlength="200"
          ></textarea>
        </div> -->
        <van-field
          v-model="content"
          class="van-textarea"
          autosize
          label="备注"
          type="textarea"
          maxlength="200"
          placeholder="备注文字限制在200字以内"
          show-word-limit
        />
      </div>
      <!--底部按钮-->
      <div class="van-submit-bar">
        <div class="van-submit-bar__bar">
          <div class="van-submit-bar__price">
            <span class="col-333 ft2">订单合计：</span>
            <span class="van-submit-bar__price-interger ft2">
              <span v-if="totalPoints">{{ totalPoints }}{{ unit }}</span>
              <span v-if="totalCash"><span v-if="totalPoints">+</span>{{ totalCash }}元 </span>
            </span>
          </div>
          <van-button
            class="van-button van-button--normal theme-bg sub-btn"
            :loading="btnLoading"
            @click="sendDadas"
            style="color: #fff"
          >
            提交订单
          </van-button>
        </div>
      </div>
    </div>
    <!--地址选择侧滑菜单-->
    <Choose-Site
      ref="ChooseSite"
      v-on:listenSitedata="setSite"
      v-if="chooseSite"
    ></Choose-Site>
    <!--缺货状态弹框-->
    <van-popup v-model="newshow" class="adven-popup userlist-popup">
      <div class="hintbox">
        <h2 class="title">提示</h2>
        <h3 class="title1">下列商品在当前配送地址库存不足</h3>
        <ul class="hintcent">
          <li style="position: relative" v-for="items in data" :key="items.id">
            <span class="noGoods">无货</span>
            <img :src="items.img_path" alt="" />
            <div class="listname ellipseal">
              <span class="tagbox">
                <span class="tag xl" v-if="items.source == 4">一乡一物</span>
                <span class="tag xl" v-if="items.source == 3">卡券</span>
                <span class="tag zc" v-if="items.source == 2">直充</span>
                <span plain class="tag jd" v-if="items.source == 1">优选</span>
                <span class="tag yx" v-if="items.source == 6">严选</span>
              </span>
              {{ items.name }}
            </div>
          </li>
        </ul>
        <div
          class="newclose theme-col"
          style="color: #fff !important"
          @click="closePop"
        >
          确定
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import extParam from "@/components/extParam.vue";
import ChooseSite from "@/pages/affirmorder/choosesite";
import Bus from "../../../static/js/bus.js";
import pay from "@/mixins/pay.js";
export default {
  name: "index",
  components: {
    ChooseSite,
    extParam
  },
  mixins: [pay],
  data() {
    return {
      numPicker: false,
      btnLoading: false, //提交按钮状态
      datas: "", //商品数据
      chosenAddressId: "", //收货地址ID
      mobile: "", //手机号
      content: "", //备注
      dummy: "", //是否是虚拟商品
      getname: "",
      getid: "",
      gettel: "",
      getaddress: "",
      newshow: false,
      cart_id: "",
      lodingshow: true,
      nums: 0, //订单商品件数
      totalPoints: 0,
      totalCash: 0,
      ajaxfrom: {},
      data: [],
      btn: false,
      inputTp: [],
      extParams: {},
      game: {
        gameList: [],
        gamePicker: false,
        gameRegionServer: [],
        gameRegionServerPicker: false,
        gameRegionServerText: "",
        chargetype: [],
        chargetypePicker: false
      }
    };
  },
  computed: {
    isChangeNumShow() {
      return vo => {
        return vo.enum && vo.enum.length > 0;
        // vo.range[0].length>0 &&vo.enum.length==0
      };
    },
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    id: function() {
      if (typeof this.$route.query.id == "string") {
        return this.$route.query.id;
      } else {
        //多个订单id并转为字符串的形式
        return this.$route.query.id.join(",");
      }
    }
  },
  methods: {
    autoTextarea(elem, extra, maxHeight) {
      let _this = this;
      extra = extra || 0;

      var isFirefox = !!document.getBoxObjectFor || "mozInnerScreenX" in window,
        isOpera = !!window.opera && !!window.opera.toString().indexOf("Opera"),
        addEvent = function(type, callback) {
          elem.addEventListener
            ? elem.addEventListener(type, callback, false)
            : elem.attachEvent("on" + type, callback);
        },
        getStyle = elem.currentStyle
          ? function(name) {
              var val = elem.currentStyle[name];

              if (name === "height" && val.search(/px/i) !== 1) {
                var rect = elem.getBoundingClientRect();

                return (
                  rect.bottom -
                  rect.top -
                  parseFloat(getStyle("paddingTop")) -
                  parseFloat(getStyle("paddingBottom")) +
                  "px"
                );
              }

              return val;
            }
          : function(name) {
              return getComputedStyle(elem, null)[name];
            },
        minHeight = parseFloat(getStyle("height"));

      elem.style.resize = "none";

      var change = function() {
        var scrollTop,
          height,
          padding = 0,
          style = elem.style;

        if (elem._length === elem.value.length) return;

        elem._length = elem.value.length;

        if (!isFirefox && !isOpera) {
          padding =
            parseInt(getStyle("paddingTop")) +
            parseInt(getStyle("paddingBottom"));
        }

        scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;

        elem.style.height = minHeight + "px";

        if (elem.scrollHeight > minHeight) {
          if (maxHeight && elem.scrollHeight > maxHeight) {
            height = maxHeight - padding;

            style.overflowY = "auto";
          } else {
            height = elem.scrollHeight - padding;

            style.overflowY = "hidden";
          }

          style.height = height + extra + "px";

          scrollTop += parseInt(style.height) - elem.currHeight;

          document.body.scrollTop = scrollTop;

          document.documentElement.scrollTop = scrollTop;

          elem.currHeight = parseInt(style.height);
        }

        if (_this.content.length <= 0) {
          elem.style.height = 48 + "px";
        }
      };

      addEvent("propertychange", change);

      addEvent("input", change);

      addEvent("focus", change);
      console.log("length :>> ", _this.content.length);

      change();

      console.log("elem :>> ", elem.style.height);
    },
    enStr(str) {
      return str.substring(0, 3) + "****" + str.substring(str.length - 4);
    },

    goBack: function() {
      history.back(-1);
    },
    godetail: function(id) {
      this.$router.push({ path: "/goodslist/goods", query: { id: id } });
    },
    closePop: function() {
      this.newshow = false;
    },
    onClickRight: function() {
      console.log("按钮");
    },
    descInput(event) {
      var txtVal = this.content.length; //desc 是设置v-model的值
      this.autoTextarea(event.target, "", 160);
      if (txtVal >= 200) {
        this.content = this.content.slice(0, 200);
        this.$dialog
          .alert({
            title: "提示",
            message: "字数不能超过200个字！"
          })
          .then(() => {
            // on close
          });
      }
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      this.$api.get(
        "order/cart/cartorderinfo",
        { id_example: mallid, token_user: isUser, id_cart: this.id },
        res => {
          if (res.data.code != "100") {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .alert({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                });
            } else {
              //              this.$toast(res.data.message);
              this.$router.push({ name: "NoteLogin" });
            }
          } else {
            if (res.data.data.list.length == 0) {
              this.goBack();
            } else {
              var source = res.data.data.list[0].source;
              if (this.source == 2 || this.source == 3) {
                this.lodingshow = false;
              } else {
                _this.datas = res.data.data.list;

                _this.dummy = res.data.data.list[0].source;
                _this.totalPoints = res.data.data.point;
                _this.totalCash = res.data.data.cash;
                $.each(res.data.data.list, function(index, item) {
                  _this.nums += item.number;
                });
                this.getAddress();
                this.setGoodsTemplate();
              }
            }
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    getAddress: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      this.$api.get(
        "user/address/list",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.data.length != 0) {
            var bool = false;
            for (var i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].default == 1) {
                bool = true;
              }
            }
            if (bool) {
              $.each(res.data.data, function(index, item) {
                if (item.default == 1) {
                  _this.chosenAddressId = item.id;
                  _this.getname = item.name;
                  _this.getid = item.id;
                  _this.gettel = item.phone;
                  _this.getaddress =
                    item.province_str +
                    item.city_str +
                    item.county_str +
                    item.town_str +
                    item.address;
                  _this.mobile = item.phone;
                }
              });
            } else {
              _this.chosenAddressId = res.data.data[0].id;
              _this.getname = res.data.data[0].name;
              _this.getid = res.data.data[0].id;
              _this.gettel = res.data.data[0].phone;
              _this.getaddress =
                res.data.data[0].province_str +
                res.data.data[0].city_str +
                res.data.data[0].county_str +
                res.data.data[0].town_str +
                res.data.data[0].address;
            }
          }
          this.lodingshow = false;
        }
      );
    },
    chooseSite: function() {
      this.$refs.ChooseSite.chooseSiteShow();
      Bus.$emit("steat", this.chosenAddressId);
    },
    setSite: function(data, id) {
      this.getname = data.name;
      this.getid = data.id;
      this.gettel = data.tel;
      this.getaddress = data.address;
      this.chosenAddressId = id;
    },
    sure: function() {
      this.ajaxfrom.pay_type = this.$store.state.webCount.buy_point;
      this.data = [];
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      // let sure=true;
      //       Object.keys(this.extParams).forEach((key, value) => {
      //   // console.log("key", this.extParams[key]);
      //   if (!this.extParams[key]) {
      //     this.$toast("请填写完整的信息");
      //     sure = false;
      //     return false;
      //   }
      // });
      // if (!sure) {
      //   this.btnLoading = false;
      //   return sure;
      // }
      this.$api.post("order/orders/confirm", this.ajaxfrom, res => {
        this.btnLoading = false;
        if (res.data.code == "100") {
          if (this.dummy == 2) {
            this.$dialog
              .confirm({
                title: "提示",
                message:
                  "是否向:“" + this.extParams["charge_account"] + "”充值？"
              })
              .then(() => {
                this.pay(res.data.data);
              })
              .catch(() => {
                this.btnLoading = false;
                // on cancel
                this.$router.push({ path: "/user/myorder/allorder" });
              });
          } else if (this.dummy == 3) {
            this.$dialog
              .confirm({
                title: "提示",
                message: "收货人手机：" + this.mobile + "</br>确认提交订单？"
              })
              .then(() => {
                this.pay(res.data.data);
              })
              .catch(() => {
                this.btnLoading = false;
                // on cancel
                this.$router.push({ path: "/user/myorder/allorder" });
              });
          } else {
            this.$dialog
              .confirm({
                title: "提示",
                message: "确定支付该订单？"
              })
              .then(() => {
                this.pay(res.data.data);
              })
              .catch(() => {
                this.btnLoading = false;
                // on cancel去未支付订单详情
                //              this.$router.push({name: 'Order', query: {orderId: res.data.data.order_sn}})
                this.$router.push({ name: "AllOrder" });
              });
          }
        } else if (res.data.code == "-88") {
          //余额不足
          this.$toast(
            this.$common.cardName().type ? "余额不足" : res.data.data
          );
        } else if (res.data.code == "-99") {
          //库存不足
          for (let i = 0; i < res.data.data.length; i++) {
            _this.data.push(res.data.data[i]);
          }
          this.newshow = true;
        } else {
          if (res.data.message == "token验证失败") {
            this.$dialog
              .confirm({
                title: "提示 ",
                message: "您还未登录是否去登录？"
              })
              .then(() => {
                this.$router.push({ name: "NoteLogin" });
              })
              .catch(() => {});
          } else {
            this.$toast(res.data.message);
          }
        }
      });
    },
    pay(id, diff_pay = 0) {
      if (this.btn == false) {
        this.btn = true;
        this.wxPay(id, diff_pay);
      }
    },
    dummygoods: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");

      if (this.dummy == 3) {
        var reg = /^[1][3456789][0-9]{9}$/;
        if (reg.test(this.mobile)) {
          this.ajaxfrom.id_example = mallid;
          this.ajaxfrom.token_user = isUser;
          this.ajaxfrom.id_cfir = this.id;
          this.ajaxfrom.remark = this.content;
          this.ajaxfrom.phone = this.mobile;

          this.sure();
        } else {
          this.$dialog
            .alert({
              title: "提示",
              message: "请填写正确的手机号码！"
            })
            .then(() => {
              // on close
              this.btnLoading = false;
            });
        }
      } else if (this.dummy == 2) {
        var reg = /^[1][3456789][0-9]{9}$/;
        if (reg.test(this.mobile)) {
          this.ajaxfrom.id_example = mallid;
          this.ajaxfrom.token_user = isUser;
          this.ajaxfrom.id_cfir = this.id;
          this.ajaxfrom.remark = this.content;
          this.ajaxfrom.phone = this.mobile;
          this.ajaxfrom.extParam = JSON.stringify(this.extParams);
          this.sure();
        } else {
          this.$dialog
            .alert({
              title: "提示",
              message: "请填写正确的手机号码！"
            })
            .then(() => {
              // on close
              this.btnLoading = false;
            });
        }
      }
    },
    sendDadas: function() {
      this.data = [];
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.btnLoading = true;
      if (this.dummy != 3 && this.dummy != 2) {
        this.ajaxfrom.id_example = mallid;
        this.ajaxfrom.token_user = isUser;
        this.ajaxfrom.id_cfir = this.id;
        this.ajaxfrom.remark = this.content;
        this.ajaxfrom.id_address = this.chosenAddressId;
        this.sure();
      } else {
        this.dummygoods();
      }
    },
    // 设置自提地址弹框显示
    setTakeTeirShow(bol, data) {
      this.takeTeirShow = bol;
      if (!data) {
        return false;
      }
      this.centreData = data;
    },

    onChangeNum(value) {
      console.log(value);
      this.nums = value;
      this.totalPoints = this.nums * this.datas[0].point;
      this.totalCash = this.nums * this.datas[0].cash;
    },

    numConfirm(val, d) {
      console.log(val);
      this.extParams["charge_num"] = val;
      this.nums = val;
      this.totalPoints = this.nums * this.datas[0].point;
      this.totalCash = this.nums * this.datas[0].cash;
      this.numPicker = false;
    },
    gameConfirm(val, d) {
      this.extParams.charge_game_name = val.game_name;
      if (val.game_region_server && val.game_region_server.length > 0) {
        let game_region_server = val.game_region_server;
        game_region_server.forEach(function(val, key) {
          if (val.region && val.server) {
            val.text = val.region + "-" + val.server;
          } else {
            if (val.region) val.text = val.region;
            else val.text = val.server;
          }
          game_region_server[key] = val;
        });
        this.game.gameRegionServer = game_region_server;
      }
      this.game.gamePicker = false;
    },
    gameRegionServerConfirm(val) {
      this.game.gameRegionServerText = val.text;
      if (val.region) this.extParams.charge_game_region = val.region;
      if (val.server) this.extParams.charge_game_srv = val.server;
      if (val.charge_type) this.game.chargetype = val.charge_type;
      this.game.gameRegionServerPicker = false;
    },
    chargetypePickerConfirm(val) {
      this.extParams.charge_type = val;
      this.game.chargetypePicker = false;
    },
    setGoodsTemplate() {
      let product_list = this.datas,
        template = product_list[0].extParams;
      if (this.dummy != 2 || !template) return;
      let parameter = template.parameter,
        specialName = [
          "charge_game_name",
          "charge_game_region",
          "charge_game_srv",
          "charge_type"
        ];
      console.log(parameter);
      let inputList = [],
        extParams = {};
      parameter.forEach((item, index) => {
        let placeholder = "请输入" + item.title;
        let range = item.range;
        let tp_enum = item.enum;
        // if(tp_enum.length>0 || range.length>0)
        // {
        //   if(range.length>0){
        //     for (let index in range)
        //     {
        //       tp_enum.unshift(range[index][0]+'-'+range[index][1]);
        //     }
        //   }
        //   placeholder += ',范围：'+tp_enum.join('|');
        // }
        // item.placeholder = placeholder;

        if (specialName.indexOf(item.name) === -1) {
          inputList.push(item);
        }
        extParams[item.name] = "";
        if (tp_enum.length > 0) {
          console.log(this.datas[0].number);
          extParams["charge_num"] = tp_enum[0];
          this.nums = tp_enum[0];
          this.totalPoints = this.nums * this.datas[0].point;
          this.totalCash = this.nums * this.datas[0].cash;
        } else {
          if (range[0]) {
            this.nums = range[0][0];
            this.totalPoints = this.nums * this.datas[0].point;
            this.totalCash = this.nums * this.datas[0].cash;
          }
        }
      });

      this.inputTp = inputList;
      this.parameter = parameter;
      console.log(this.parameter);
      console.log(this.inputTp);
      this.game.gameList = template.game_list;
      this.extParams = extParams;
    }
  },
  created() {},
  mounted() {
    this.getDatas();
  }
};
</script>

<style lang="less">
.van-textarea {
  flex-direction: column !important;
}
.affirmorderindex {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 1rem;
  .pop {
    background-color: #fff !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    .van-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -0.15rem 0 0 -0.15rem;
    }
  }

  .addressList {
    background: transparent !important;
    .van-radio-group {
      background: transparent !important;
    }
    .van-cell-group {
      background: #f5f5f5;
      .van-cell {
        margin-bottom: 0.1rem;
      }
    }
  }
  .van-content {
    padding-bottom: 0;

    .van-field {
      padding: 0.3rem 0.3rem;
      .van-cell__title {
        width: 2rem;
        font-size: 0.28rem;
        font-weight: 500;
        color: rgba(38, 38, 38);
      }
    }

    .tishi {
      width: 100%;
      height: 0.6rem;
      background: #feeeec;
      font-size: 0.24rem;
      font-weight: 400;
      color: #fe5c42;
      line-height: 0.6rem;
      padding-left: 0.3rem;
    }
  }
  /*消息弹框*/
  .userlist-popup {
    background-color: inherit;
    width: 80%;
    border-radius: 0.24rem;
    .hintbox {
      position: relative;
      background: #fff;
      padding-bottom: 0.4rem;
      .title {
        padding-top: 0.25rem;
        border-radius: 0.32rem 0.32rem 0 0;
        text-align: center;
        font-size: 0.32rem;
        background: #fff;
      }
      .title1 {
        padding-top: 0.2rem;
        text-align: center;
        font-size: 0.28rem;
        background: #fff;
        padding-bottom: 0.42rem;
        border-bottom: 0.02rem solid #f2f2f2;
      }
      li {
        position: relative;
        padding: 0.2rem 0 0.1rem 0;
        .listname {
          padding-left: 2rem;
          position: absolute;
          top: 0.2rem;
          left: 0;
          font-size: 0.26rem;
          font-weight: 500;
          color: #262626;
          line-height: 0.42rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }

        img {
          width: 1.8rem;
          height: 1.8rem;
          border-radius: 0.16rem;
        }

        .noGoods {
          display: inline-block;
          width: 0.96rem;
          height: 0.96rem;
          position: absolute;
          left: 0.43rem;
          top: 0.62rem;
          background: rgba(0, 0, 0, 0.4);
          color: #fff;
          font-size: 0.32rem;
          line-height: 0.96rem;
          text-align: center;
          border-radius: 50%;
        }
      }
      .hinttit {
        font-size: 0.32rem;
        text-align: center;
        padding: 0.3rem 0;
      }
      .newclose {
        width: 4rem;
        height: 0.8rem;
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        border-radius: 0.48rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #ffffff !important;
        text-align: center;
        line-height: 0.8rem;
        margin: 0 auto;
        margin-top: 0.2rem;
      }
      .hintcent {
        background-color: #fff;
        /*border-radius: .1rem;*/
        padding: 0.3rem 0.6rem;
        min-height: 1.65rem;
        max-height: 4rem;
        overflow-y: auto;
        color: #666;
        font-size: 0.24rem;
        border-bottom: 0.01rem solid #f5f5f5;
        .van-button {
          height: 0.8rem;
          padding: 0 0.8rem;
          border-radius: 0.4rem;
          margin-top: 0.4rem;
          font-size: 0.32rem;
          background: #fe2b3c;
          border: none;
          color: #fff !important;
          box-shadow: 0rem 0.08rem 0.6rem #fe2b3c;
        }
      }
    }
    .userlist {
      padding: 0.035rem 0.3rem;
    }
  }
  /*弹框结束*/
  .popupleft {
    width: 100%;
    height: 100%;
  }
  .van-cell {
    background-color: #fff;
  }
  .van-cell-group {
    /*margin-top: .1rem;*/
    /*background-color: #fff;*/
  }
  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
  .van-address-list__add {
    display: none;
  }
  .hasAddress {
    .van-cell {
      padding-bottom: 0rem;
      background: #fff;
      padding: 0.4rem 0.3rem !important;

      .van-address-item__name {
        font-size: 0.32rem;
        font-weight: 500;
        color: #262626;
        line-height: 0.44rem;
      }

      .van-address-item__address {
        font-size: 0.26rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.36rem;
      }
    }
  }
  .van-address-list__group {
    padding-bottom: 0rem;
    background: #fff;
    /*background: url("/static/images/addreLine.png") no-repeat center;
	    background-size:100% 100%;*/
  }

  .icon-shouhuodizhi {
    font-size: 0.22rem;
    margin-right: 0.1rem;
    line-height: 0.7rem;
  }
  .goodsonelist {
    margin: 0 !important;
    background: #fff;
    height: 100%;

    .van-card__content {
      position: relative;
      padding-top: 0.1rem;

      .product-name {
        font-size: 0.26rem;
        font-weight: 500;
        color: #262626;
        line-height: 0.42rem;
      }

      .van-card-desc {
        width: 100%;
        position: absolute;
        bottom: 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .price {
          font-size: 0.28rem;
          font-weight: 400;
          color: #262626;
          line-height: 0.48rem;
        }

        .num {
          font-size: 0.24rem;
          font-weight: 400;
          color: #929292;
          line-height: 0.42rem;
        }
      }
    }

    .van-card__thumb {
      width: 2.2rem;
      height: 2.2rem;

      .goodsimgbox {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .add_address {
    height: 1.54rem;
    margin-bottom: 0.1rem;
    background-color: #fff;
    position: relative;
    margin-bottom: 0.2rem;

    .van-notice-bar__right-icon {
      right: 0.05rem;
    }
    .van-cell__value {
      text-align: center;
      vertical-align: middle;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.32rem;
      font-weight: 500;
      color: #262626;
      line-height: 0.44rem;
    }
  }
  .allinfo {
    padding: 0.36rem;
    display: flex;
    justify-content: space-between;

    .allinfo-left {
      font-size: 0.28rem;
      font-weight: 500;
      color: rgba(38, 38, 38, 0.5);
      line-height: 0.48rem;
    }

    .allinfo-right {
      font-size: 0.28rem;
      font-weight: 400;
      color: #262626;
      line-height: 0.48rem;
    }
  }
  .beizhu {
    margin-top: 0.2rem;
    display: flex;
    flex-direction: column;

    .van-cell__title {
      font-size: 0.28rem;
      font-weight: 400;
      color: rgba(38, 38, 38, 0.5);
      line-height: 0.48rem;
    }

    .van-field__control {
      margin-top: 0.1rem;
      flex: 1;
      text-align: left;
      overflow: -moz-scrollbars-none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }

      &::placeholder {
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.48rem;
      }
    }
  }

  .van-submit-bar {
    width: 100%;
    background: #ffffff;

    .van-submit-bar__bar {
      box-sizing: border-box;
      width: 100%;
      height: 1.18rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .van-submit-bar__price {
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.4rem;

        .ft2 {
          color: rgba(254, 92, 66, 1);
        }

        .col-333 {
          color: rgba(38, 38, 38, 1);
        }
      }

      .sub-btn {
        width: 2.5rem;
        height: 0.8rem;
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        border-radius: 0.48rem;
      }
    }
  }
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/affirmorder/index.vue